"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthContext = exports.AuthActions = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* istanbul ignore file */


var AuthActions;
exports.AuthActions = AuthActions;

(function (AuthActions) {
  AuthActions["LOGIN"] = "LOGIN";
  AuthActions["LOGOUT"] = "LOGOUT";
})(AuthActions || (exports.AuthActions = AuthActions = {}));

var AuthContext = _react["default"].createContext({
  state: false,
  dispatch: function dispatch() {
    return null;
  }
});

exports.AuthContext = AuthContext;